/* FÉNIX R07.76 — footer social centering + explicit light/dark mode labels */
(function(){
  'use strict';

  function markSocial(){
    var footer=document.querySelector('footer.site-footer');
    if(!footer)return;
    var icons=footer.querySelector('.social-icons');
    var wrap=icons&&icons.closest?icons.closest('.grid__item'):null;
    if(wrap)wrap.classList.add('nm-footer-social-centered');
  }

  function currentTheme(){
    var root=document.documentElement;
    var value=root.getAttribute('data-nm-theme')||root.getAttribute('data-theme');
    return value==='light'?'light':'dark';
  }

  function syncThemeLabels(){
    var theme=currentTheme();
    var label=theme==='light'?'Modo oscuro':'Modo claro';
    var controls=document.querySelectorAll('.nm-theme-toggle');
    for(var i=0;i<controls.length;i++){
      var button=controls[i];
      button.setAttribute('title',label);
      button.setAttribute('aria-label',label);
      button.setAttribute('data-nm-mode-label',label);
      var children=button.children||[];
      for(var j=0;j<children.length;j++){
        var child=children[j];
        if(child.tagName==='SPAN'&&!child.classList.contains('nm-theme-icon')){
          if(child.textContent!==label)child.textContent=label;
        }
      }
    }
  }

  function init(){
    markSocial();
    syncThemeLabels();
    window.addEventListener('nm:themechange',function(){
      if(window.requestAnimationFrame){window.requestAnimationFrame(syncThemeLabels);}else{syncThemeLabels();}
    });
    window.addEventListener('pageshow',syncThemeLabels);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',init,{once:true});
  }else{
    init();
  }
})();
